<template>
  <div class="portal__content claim__details">
    <div class="claim__item">
      <div class="claim__content">
        <h3 class="claim__item--title title--l">{{ getUiString(['claim_details','details', 'my_claim', 'title']) }}</h3>
        <div class="row">
          <div class="cell">
            <div class="label">{{ getUiString(['claim_details','details', 'my_claim', 'claimnumber']) }}</div>
            <div class="value">{{ currentClaim.ReferenceNumber }}</div>
          </div>
          <div class="cell">
            <div class="label">{{ getUiString(['claim_details','details', 'my_claim', 'flight_issue']) }}</div>
            <div class="value">{{ incidentType }}</div>
          </div>
        </div>
        <div class="row">
          <div class="cell">
            <div class="label">{{ getUiString(['claim_details','details', 'my_claim', 'claimed_by']) }}</div>
            <div v-for="p in submittedFor" :key="p" class="value">{{p}}</div>
          </div>
          <div v-if="hasCompensation" class="cell">
            <div class="label">{{ compensationLabel }}</div>
            <div class="value">{{ formatCurrency }}</div>
          </div>
        </div>
      </div>
      <div v-if="currentClaim.ClientRemarks" class="row">
        <div class="cell">
          <div class="label">{{ getUiString(['claim_details','details', 'my_claim', 'extra_info']) }}</div>
          <div class="value">{{ currentClaim.ClientRemarks }}</div>
        </div>
      </div>
    </div>
    <claim-details-tab-item detailsSection="Passengers"></claim-details-tab-item>
    <add-passenger v-if="canAddPassenger"></add-passenger>
    <claim-details-tab-item detailsSection="Bankdetails"></claim-details-tab-item>
    <claim-details-tab-item detailsSection="Documents" v-if="!currentClaim.ClaimClosed"></claim-details-tab-item>
    <base-file-view v-if="viewerData" :document="viewerData" @close="viewerData = null"></base-file-view>
    <claim-quote v-if="currentClaim.CanAddQuote && !currentClaim.ClaimClosed"></claim-quote>
    <button class="button button--sec" @click="downloadOverview">{{ getUiString(['claim_details','details', 'my_claim', 'download_overview']) }}</button>
  </div>
</template>

<script>
import ClaimDetailsTabItem from '@/components/claims/ClaimDetailsTabItem.vue'
import ClaimQuote from '@/components/claims/ClaimQuote.vue'
import AddPassenger from '@/components/person/AddPassenger.vue'
import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver'

export default {
  name: 'ClaimDetailsTab',
  components: {
    ClaimDetailsTabItem,
    ClaimQuote,
    AddPassenger
  },
  data () {
    return {
      error: false,
      viewerData: null
    }
  },
  computed: {
    ...mapGetters({
      currentClaim: 'claim/currentClaim',
      getUiString: 'uistrings/getUiString',
      claimId: 'claim/claimId'
    }),
    submittedFor () {
      return this.currentClaim.Passengers.map(p => {
        const tussen = p.MiddleName ? p.MiddleName + ' ' : ''
        return `${p.FirstName} ${tussen}${p.LastName}`
      })
    },
    canAddPassenger () {
      return this.currentClaim.CanAddPassenger
    },
    compensationLabel () {
      switch (this.currentClaim.ClaimType) {
        case 'Regulation_261_2004':
          return this.getUiString(['claim_details', 'details', 'my_claim', 'compensation_per_passenger'])
        case 'Regulation_889_2002':
          return this.getUiString(['claim_details', 'details', 'my_claim', 'compensation_luggage'])
        case 'Regulation_889_2002_Flight':
          return this.getUiString(['claim_details', 'details', 'my_claim', 'compensation_extra_costs'])
      }
      return ''
    },
    hasCompensation () {
      const cpp = parseFloat(this.currentClaim.CompensationPerPassenger)
      const tcv = parseFloat(this.currentClaim.TotalClaimValue)
      return cpp > 0 || tcv > 0
    },
    formatCurrency () {
      const cpp = parseFloat(this.currentClaim.CompensationPerPassenger)
      const tcv = parseFloat(this.currentClaim.TotalClaimValue)
      const val = cpp > 0 ? cpp : tcv
      if (val > 0) {
        const precision = val === Math.round(val) ? 0 : 2
        return `€ ${val.toFixed(precision).replace('.', ',')}`
      }
      return ''
    },
    incidentType () {
      const incType = this.currentClaim.ClaimType === 'Voucher_Flight' ? 'cs_Voucher'
        : `cs_${this.currentClaim.ClaimType}_${this.currentClaim.IncidentType}`
      return this.getUiString(['claim_regulations', incType])
    }
  },
  methods: {
    async downloadOverview () {
      const result = await this.$store.dispatch('claim/downloadOverview', { claimId: this.claimId })
      if (result) {
        saveAs(result, `claim-${this.currentClaim.ReferenceNumber}-summary-report.pdf`)
      }
    }
  }
}
</script>
